import axios from '../utils/requset';

const apply = {
    // 村委
    statusChange(params) {
        return axios.get("/service-app/temporary/detail", { params });
    },
}

export default apply;